import slide1 from '@@/assets/images/landing-pages/how-to/carousel/carousel_1.png'
import slide1Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_1@2x.png'

import slide2 from '@@/assets/images/landing-pages/how-to/carousel/carousel_2.png'
import slide2Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_2@2x.png'

import slide3 from '@@/assets/images/landing-pages/how-to/carousel/carousel_3.png'
import slide3Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_3@2x.png'

import slide4 from '@@/assets/images/landing-pages/how-to/carousel/carousel_4.png'
import slide4Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_4@2x.png'

import slide5 from '@@/assets/images/landing-pages/how-to/carousel/carousel_5.png'
import slide5Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_5@2x.png'

import slide6 from '@@/assets/images/landing-pages/how-to/carousel/carousel_6.png'
import slide6Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_6@2x.png'

import slide7 from '@@/assets/images/landing-pages/how-to/carousel/carousel_7.png'
import slide7Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_7@2x.png'

import slide8 from '@@/assets/images/landing-pages/how-to/carousel/carousel_8.png'
import slide8Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_8@2x.png'

import slide9 from '@@/assets/images/landing-pages/how-to/carousel/carousel_9.png'
import slide9Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_9@2x.png'

import slide10 from '@@/assets/images/landing-pages/how-to/carousel/carousel_10.png'
import slide10Retina from '@@/assets/images/landing-pages/how-to/carousel/carousel_10@2x.png'

export const CONTENTS = {
  sell: {
    title: 'tudo que você precisa<span class="t-md-block"> saber para vender muito no enjoei </span>',
    description: 'vender roupas online ressignifica a sua relação com as coisas do mundo, <span class="t-md-block"> faz a energia circular e ainda te garante um money. você pode, quem sabe, adquirir um iate :)</span>',
    actionText: 'quero vender',
    actionLink: '/quero-vender'
  },

  buy: {
    title: 'comprar no enjoei é fácil e seguro',
    description: 'basicamente é: clicou, pagou, levou.',
    actionText: 'quero comprar',
    actionLink: '/'
  }
}

export const SLIDES = [
  {
    id: 1,
    alt: 'Foto de um colete feminino preto e branco por cima de uma camisa branca.',
    image: {
      normal: slide1,
      retina: slide1Retina
    }
  },
  {
    id: 2,
    alt: 'Foto de uma mulher vestindo blusa semi transparente bege com estampa de onça e shorts jeans.',
    image: {
      normal: slide2,
      retina: slide2Retina
    }
  },
  {
    id: 3,
    alt: 'Foto de uma mão feminina segurando um coturno marrom.',
    image: {
      normal: slide3,
      retina: slide3Retina
    }
  },
  {
    id: 4,
    alt: 'Foto de um quimono coral com estampa tropical pendurado em um cabide preso a uma árvore.',
    image: {
      normal: slide4,
      retina: slide4Retina
    }
  },
  {
    id: 5,
    alt: 'Foto de uma sandália com tiras de plástico na cor preta da marca Melissa.',
    image: {
      normal: slide5,
      retina: slide5Retina
    }
  },
  {
    id: 6,
    alt: 'Foto de um colete feminino verde claro de tricô em sobreposição a uma camisa branca.',
    image: {
      normal: slide6,
      retina: slide6Retina
    }
  },
  {
    id: 7,
    alt: 'Foto de uma mulher vestindo blusa romântica azul marinho de gola alta e babados frontais em conjunto com calça amarela de cós alto.',
    image: {
      normal: slide7,
      retina: slide7Retina
    }
  },
  {
    id: 8,
    alt: 'Foto de uma mulher vestindo uma jaqueta jeans azul com botões abertos na frente em conjunto com blusa cropped e calça preta.',
    image: {
      normal: slide8,
      retina: slide8Retina
    }
  },
  {
    id: 9,
    alt: 'Foto de uma mão apresentando um tênis com listras curvas nas cores branco, preto, cinza, vermelho e creme da marca Nike.',
    image: {
      normal: slide9,
      retina: slide9Retina
    }
  },
  {
    id: 10,
    alt: 'Foto de uma bata de manga curta estampada com tema indiano nas cores preto, bordô e creme pendurada em cabide.',
    image: {
      normal: slide10,
      retina: slide10Retina
    }
  }
]
